// Email service using Netlify Functions
// This will call our server-side Netlify function to send emails

// Direct email sending using Netlify function
const sendEmail = async (templateType, formData) => {
  try {
    // Add user agent and other browser info
    const emailData = {
      ...formData,
      templateType,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      userIP: await getUserIP(), // Get user's IP address
      website: 'insightdigitalagency.com'
    };

    // Call the Netlify function
    const response = await fetch('/.netlify/functions/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(emailData)
    });

    const result = await response.json();

    if (response.ok && result.success) {
      return { 
        success: true, 
        message: result.message
      };
    } else {
      throw new Error(result.message || 'Form submission failed');
    }
    
  } catch (error) {
    console.error('Email sending failed:', error);
    
    // Fallback: Still try to provide a good user experience
    return { 
      success: false, 
              message: 'Unable to send message at this time. Please email us directly at karen@insightdigitalagency.com or call 913-513-1525.' 
    };
  }
};

// Get user's IP address for logging purposes
const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    return 'Unknown';
  }
};

// Export functions
export const sendContactForm = (formData) => sendEmail('contact', formData);
export const sendNewsletterSubscription = (email) => sendEmail('newsletter', { email });
export const sendChatMessage = (message) => sendEmail('chat', { message }); 